// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"e673d3ac","110":"a003c1e0","274":"d3b99cd6","365":"da063ebe","660":"f827c515","848":"e87a825f"}[chunkId] + ".chunk.js";
};